import { style, animate, transition } from '@angular/animations';

export const fadeInOutAnimation = [
  transition(':enter', [
    style({ opacity: 0 }),
    animate('100ms ease-in-out', style({ opacity: 1 }))
  ]),
  transition(':leave', [
    animate('400ms ease-in-out', style({ opacity: 0 }))
  ])
];
